import PhotoSwipe from "photoswipe";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import PageLoadedQueue from "../../../../../../../Avency.Nwd.Base/Resources/Private/JavaScript/Project/PageLoadedQueue";


/**
 * Initialize the gallery
 */
export function initGallery(
    gallery: string|HTMLElement,
    children: string,
    withDownloadButton: boolean = true,
    withCaption: boolean = true,
    withArrows: boolean = true,
    withZoom: boolean = true,
    withClose: boolean = true,
    withCounter: boolean = true,
): PhotoSwipeLightbox {
    const lightbox = new PhotoSwipeLightbox({
        gallery: gallery,
        children: children,
        // @ts-ignore
        pswpModule: () => PhotoSwipe,
        imageClickAction: 'close',
        tapAction: 'close',
        mainClass: 'gallery-slider--pswp-container',
        arrowPrevSVG: '<i class="ai ai-chevron-left"></i>',
        arrowNextSVG: '<i class="ai ai-chevron-right"></i>',
        closeSVG: '<i class="ai ai-remove"></i>',
        zoomSVG: '<i class="ai ai-zoom-in photoswipe-zoom-in-icon"></i><i class="ai ai-zoom-out photoswipe-zoom-out-icon"></i>',
        arrowPrev: withArrows,
        arrowNext: withArrows,
        zoom: withZoom,
        close: withClose,
        counter: withCounter,
    });

    if (withDownloadButton || withCaption) {
        lightbox.on('uiRegister', function () {
            // download button
            if (withDownloadButton) {
                lightbox.pswp.ui.registerElement({
                    name: 'download-button',
                    order: 8,
                    isButton: true,
                    tagName: 'a',

                    // SVG with outline
                    html: '<i class="ai ai-download"></i>',

                    onInit: (el: HTMLLinkElement, pswp) => {
                        el.setAttribute('download', '');
                        el.setAttribute('target', '_blank');
                        el.setAttribute('rel', 'noopener');

                        pswp.on('change', () => {
                            el.href = pswp.currSlide.data.src;
                        });
                    }
                });
            }

            // caption
            if (withCaption) {
                lightbox.pswp.ui.registerElement({
                    name: 'custom-caption',
                    order: 1,
                    isButton: false,
                    appendTo: 'root',
                    html: '',
                    onInit: (el, pswp) => {
                        lightbox.pswp.on('change', () => {
                            const currSlideElement = lightbox.pswp.currSlide.data.element;
                            let captionHTML = '';
                            if (currSlideElement) {
                                const hiddenCaption = currSlideElement.querySelector('figcaption');
                                if (hiddenCaption) {
                                    // get caption from element with class hidden-caption-content
                                    captionHTML = hiddenCaption.innerHTML;
                                } else {
                                    // get caption from alt attribute
                                    captionHTML = currSlideElement.querySelector('img').getAttribute('alt');
                                }
                            }
                            el.innerHTML = captionHTML || '';
                        });
                    }
                });
            }
        });
    }

    lightbox.init();

    return lightbox;
}

/**
 * Initialize all default galleries
 */
export function initGalleries(
    gallerySelector: string = '.gallery-slider-wrapper--gallery-wrapper',
    childrenSelector: string = '.gallery-slider-item'
) {
    const galleries: NodeListOf<HTMLElement> = document.querySelectorAll(gallerySelector);

    if (galleries) {
        galleries.forEach((gallery) => {
            initGallery(gallery, childrenSelector);
        });
    }
}

/**
 * Initialize all gallery sliders
 */
export function initGallerySlider() {
    const gallerySlider: NodeListOf<HTMLElement> = document.querySelectorAll('.gallery-slider--slider-wrapper');
    if (gallerySlider) {
        gallerySlider.forEach((gallery) => {
            $(gallery).slick({
                accessibility: false,
                arrows: true,
                dots: true,
                draggable: true,
                infinite: true,
                adaptiveHeight: false,
            });

            initGallery(
                '.gallery-slider--slider-wrapper.slick-initialized',
                '.slick-slide:not(.slick-cloned) .gallery-slider-item',
            );
        });
    }
}

export function initJustifiedGalleries() {
    if ($(".theme-justified").length === 0) {
        return;
    }

    // @ts-ignore
    $(".theme-justified").justifiedGallery(
        {
            selector:       '.gallery-element, > div:not(.spinner)',
            imgSelector:    '.gallery-element-thumbnail',
            rowHeight:      350,
            maxRowHeight:   500,
            captions:       true,
            margins:        5,
            lastRow:        'justify'
        }
    );
}

PageLoadedQueue.addFunction(initGalleries);
PageLoadedQueue.addFunction(initGallerySlider);
PageLoadedQueue.addFunction(() => {
    initGalleries('.lightbox-images', 'a');
});
PageLoadedQueue.addFunction(initJustifiedGalleries);
